

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _choice = require('xo-models/src/choice');

var _index = require('xo-models/src/checkout/index');

var _index2 = require('xo-models/src/fi/index');

var _index3 = require('xo-models/src/credit/index');

var _index4 = require('xo-models/src/auth/index');

var _fiMeta = require('xo-models/src/fiMeta');

var _fiMeta2 = _interopRequireDefault(_fiMeta);

require('xo-tray-height/dist/directive');

require('xo-ui-components/src/popup/directive');

require('xo-ui-components/src/experience/directive');

require('xo-ui-components/src/fi-panel/directive');

require('xo-page-components/src/aside-header/directive');

require('xo-ui-components/src/accessibility/directive');

require('xo-ui-components/src/expired-fi-panel/directive');

var _marketingoffer = require('xo-models/src/marketingoffer');

var _newMember = require('xo-models/src/newMember');

var _factory = require('xo-ui-components/src/expired-fi-panel/factory');

var _cardartInstrument = require('../services/cardart-instrument');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

var _experiments = require('xo-models/src/experiments');

var Experiments = _interopRequireWildcard(_experiments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-wallet',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        promotion: {
            type: 'var',
            required: false
        },
        installment: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                choiceVariant: _choice.$ChoiceEligibility.instance().getVariant(this.props.token),
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                fiMeta: _fiMeta2['default'].instance(this.props.token).fetch()['catch'](_angular.noop)
            };
        },
        disallowedInstruments: function disallowedInstruments(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    expired: _factory.$ExpiredFiPanelFactory.getAllInstruments(models)
                };
            });
        },
        fiSource: function fiSource(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    isCardArtExp: _cardartInstrument.$CardArtInstrument.isCardArtEnable(models.fiMeta),
                    isBillingNoPurchase: models.cart && models.cart.isBillingNoPurchase()
                };
            });
        }
    },

    lifecycle: {
        enter: function enter() {
            this.isDE = _squid.$locale.country === 'DE';
        },
        populate: function populate() {
            var _this = this;

            var $scope = this;
            var creditDataModel = void 0;

            $scope.locale = _squid.$locale;
            $scope.showDisallowedMessage = false;

            $scope.toggleDisallowedMessage = function () {
                $scope.showDisallowedMessage = !$scope.showDisallowedMessage;
            };

            $scope.doneFn = function (result) {
                if ($scope.checkoutSession.plan.paypal_credit && $scope.installment.showCYCO) {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                } else {
                    _uiRouter.$state.go('checkout.review');
                }
            };

            $scope.showDualFi = (0, _squid.$feature)('addBank');
            $scope.padToggleFeature = _uiRouter.$stateParams.padToggleFeature;
            $scope.memberSegment = _marketingoffer.$MemberSegmentModel.instance();

            $scope.isPadToggleFeatureApplicable = function () {
                var applicable = false;

                if ($scope.padToggleFeature && $scope.padToggleFeature.applicable && $scope.padToggleFeatureSupported && $scope.padToggleFeature) {
                    applicable = true;
                }

                return applicable;
            };

            var isCreditInWallet = void 0;
            var isCoreSACEligible = void 0;

            var CREDIT_TYPE = {
                'CORE': 'CORE',
                'SAC': 'SAC',
                'EZP': 'EZP',
                'NI': 'NI'
            };

            var getMORSCreditIncentiveCampaign = function getMORSCreditIncentiveCampaign(MORSCampaigns) {
                var creditIncentiveCampaign = null;

                Object.keys(MORSCampaigns).forEach(function (key) {
                    // A "credit incentive" campaign is one that contains
                    // the "incentiveOfferProgramId" property
                    if (MORSCampaigns[key] && MORSCampaigns[key].hasOwnProperty('incentiveOfferProgramId')) {
                        creditIncentiveCampaign = MORSCampaigns[key];
                    }
                });
                return creditIncentiveCampaign;
            };

            var getCreditIncentiveBanner = function getCreditIncentiveBanner(creditIncentiveCampaign) {
                return {
                    bodyText: creditIncentiveCampaign.OfferText1,
                    bodyText2: creditIncentiveCampaign.OfferText2,
                    ctaText: (0, _squid.$renderContent)('offers.assetLite.bmlOfferPassiveCta'),
                    termsText: creditIncentiveCampaign.TermsText,
                    termsLink: creditIncentiveCampaign.TermsLink,
                    termsLinkText: creditIncentiveCampaign.TermsLinkText
                };
            };

            var getDefaultBanner = function getDefaultBanner(creditType, amount, termsLink) {
                if (creditType === CREDIT_TYPE.CORE) {
                    return {
                        bodyText: (0, _squid.$renderContent)('offers.assetLite.bmlOfferPassiveDetails', { cartAmount: amount }),
                        ctaText: (0, _squid.$renderContent)('offers.assetLite.bmlOfferPassiveCta'),
                        termsText: (0, _squid.$renderContent)('offers.subjectToApproval'),
                        termsLink: termsLink,
                        termsLinkText: (0, _squid.$renderContent)('offers.seeTermsText')
                    };
                } else if (creditType === CREDIT_TYPE.NI) {
                    return {
                        bodyText: (0, _squid.$renderContent)('offers.assetLite.bmlOfferNIWalletDetails'),
                        ctaText: (0, _squid.$renderContent)('offers.assetLite.bmlOfferPassiveCta'),
                        termsText: (0, _squid.$renderContent)('offers.subjectToApproval'),
                        termsLink: termsLink,
                        termsLinkText: (0, _squid.$renderContent)('offers.seeTermsText')
                    };
                } else if (creditType === CREDIT_TYPE.EZP) {
                    return {
                        bodyText: (0, _squid.$renderContent)('offers.assetLite.bmlOfferPassiveEZPDetails', { cartAmount: amount }),
                        ctaText: (0, _squid.$renderContent)('offers.assetLite.bmlOfferPassiveEZPCta'),
                        termsText: (0, _squid.$renderContent)('offers.subjectToApproval'),
                        termsLink: termsLink,
                        termsLinkText: (0, _squid.$renderContent)('offers.seeTermsText')
                    };
                }
            };

            var initializePadToggleFeature = function initializePadToggleFeature() {
                if ($scope.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                    return Experiments.padToggleFeatureSupported().then(function (result) {
                        $scope.padToggleFeatureSupported = result;
                    });
                }

                return _squid.$promise.resolve();
            };

            $scope.isUSGambling = function () {
                // US Only Real Money Gaming
                var isUSBuyer = _squid.$locale.country === 'US';
                var isUSmerchant = $scope.checkoutAppData && $scope.checkoutAppData.get('merchant.merchant_country') === 'US';
                var isGambling = $scope.payee && $scope.payee.isGambling();

                return isGambling && isUSBuyer && isUSmerchant;
            };

            (0, _squid.$populate)($scope, {
                auth: _index4.$AuthModel.instance($scope.token),
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
                checkoutCart: _index.$CheckoutCartModel.create($scope.token),
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
                payee: _index.$CheckoutPayeeModel.instance($scope.token)
            }).then(function () {
                _squid.$promise.all([_newMember.$NewMemberEligibility.instance().isNmj($scope.token), initializePadToggleFeature()]).then(function (_ref) {
                    var newMemberResult = _ref[0];


                    var padToggleApplicable = $scope.checkoutSession.fundingOptions.isPadToggleApplicable();

                    if (padToggleApplicable && $scope.padToggleFeatureSupported && $scope.padToggleFeature === null) {

                        $scope.padToggleFeature = {
                            applicable: padToggleApplicable
                        };
                    }

                    $scope.isCurrentPlanPad = $scope.checkoutSession.plan.isPAD();
                });
            }).then(function () {
                creditDataModel = _index3.$CreditDataModel.instance($scope.token);
                var fundingInstruments = _index.$CheckoutSessionModel.instance($scope.token).get('fundingOptions.instruments');

                isCreditInWallet = _squid.$util.find(fundingInstruments, function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });
                isCoreSACEligible = $scope.checkoutSession.creditOffer;

                var getCreditType = function getCreditType(creditOfferIntensity, isInst) {
                    // Check if there is an offer already selected
                    var instModel = _index3.$CreditInstallmentModel.instance($scope.token);

                    if (instModel && instModel.creditType === CREDIT_TYPE.SAC) {
                        return CREDIT_TYPE.SAC;
                    } else if (instModel && instModel.creditType === CREDIT_TYPE.NI) {
                        return CREDIT_TYPE.NI;
                    } else if (isInst) {
                        return CREDIT_TYPE.EZP;
                    } else if (creditOfferIntensity === 1) {
                        return CREDIT_TYPE.NI;
                    } else if (creditOfferIntensity === 2) {
                        return CREDIT_TYPE.CORE;
                    }
                    _logger.$logger.warn('unknown_credit_type');
                };

                var mapDefaultToBanner = function mapDefaultToBanner(creditReuseTerms, creditTerms) {
                    $scope.useFallbackBanner = true;

                    _logger.$logger.info('checkout_fpti', {
                        'banner_type': 'ACQUISITION_wallet'
                    });

                    $scope.banner = getDefaultBanner(getCreditType($scope.installment.creditOfferIntensity, $scope.installment.installmentOptionsPresent), $scope.checkoutCart.get('purchase.amounts.total.amount_formatted'), isCreditInWallet ? creditReuseTerms : creditTerms);
                };

                var mapCreditIncentiveToBanner = function mapCreditIncentiveToBanner(creditIncentive) {
                    $scope.useCreditIncentiveBanner = true;

                    _logger.$logger.info('checkout_fpti', {
                        'banner_type': 'ACQUISITION_wallet'
                    });

                    $scope.banner = getCreditIncentiveBanner(creditIncentive);
                };

                if (_squid.$locale.country === 'US' && !isCreditInWallet) {
                    $scope.banner = {};
                    var creditIncentive = getMORSCreditIncentiveCampaign($scope.$root.MORS || {});

                    if (creditIncentive) {
                        return mapCreditIncentiveToBanner(creditIncentive);
                    }

                    return mapDefaultToBanner(_squid.$config.urls.creditReuseTerms, _squid.$config.urls.creditTerms);
                }
            }).then(function () {
                $scope.isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
                $scope.isBilling = $scope.checkoutCart.isBilling();
                var disallowedList = $scope.checkoutSession.get('fundingOptions.disallowedInstruments');
                if (disallowedList) {
                    $scope.disallowedInstruments = $scope.disallowedInstruments.expired.length && $scope.disallowedInstruments.expired.filter(function (i) {
                        return disallowedList.includes(i);
                    });
                }

                if (!$scope.isBillingNoPurchase && $scope.disallowedInstruments && $scope.disallowedInstruments.length > 0) {
                    $scope.displayPosition = true;
                }
                if ((0, _squid.$feature)('giftCard')) {
                    $scope.showGC = Math.random() < 0.01 && !$scope.isBillingNoPurchase;

                    if ($scope.showGC) {
                        _logger.$logger.info('wallet_gift_card_redeem_link_shown');
                    } else {
                        _logger.$logger.info('wallet_gift_card_redeem_link_not_shown');
                    }
                }

                // Manage wallet feature can be turned on by country.
                // User will see manage link on wallet page if feature is turned on and has FIs allowed to edit.
                if ((0, _squid.$feature)('enableManageWallet')) {
                    var instruments = $scope.checkoutSession.get('fundingOptions.instruments');
                    var managebleFIs = _squid.$util.filter(instruments, function (funding) {
                        if (funding && !funding.editDisallowedMsg) {
                            return funding;
                        }
                    });

                    $scope.showManageLink = managebleFIs && managebleFIs.length > 0;
                }

                $scope.checkoutSession.message = null;
                $scope.showAddLink = _squid.$locale.country !== 'DE';
                $scope.showPlcc = $scope.checkoutSession.plccOffer && !$scope.checkoutCart.isBilling();

                $scope.showBML = function () {
                    return _squid.$locale.country !== 'GB' && !isCreditInWallet && isCoreSACEligible && !$scope.installment.showWalletBanner && !creditDataModel.isRedirectFromCape();
                };

                $scope.bml = function () {
                    // TODO: Deprecate creditOffer() - installment should not be a different banner
                    if ($scope.installment.showWalletBanner) {
                        _uiRouter.$state.go('checkout.chooseCreditOffer');
                    } else {
                        _uiRouter.$state.go('checkout.redirectToCape');
                    }
                };

                $scope.onRedeemGC = function () {
                    throw new _squid.$FallbackError({
                        reason: 'redeem_coupon_feature_not_supported',
                        product: 'ux',
                        entryPoint: 'giftCard'
                    });
                };

                $scope.addPlcc = function () {
                    if ($scope.promotion) {
                        $scope.promotion.type = 'plcc';
                    }
                    _uiRouter.$state.go('checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard');
                };

                $scope.cardModel = new _index2.$AddCardModel({
                    card: new _index2.$CardModel()
                });

                $scope.creditOffer = function () {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                };

                $scope.showBannerinWallet = function () {
                    if ($scope.installment.showBanner && _squid.$locale.country === 'GB') {
                        if ($scope.installment.installmentOptionsPresent) {
                            $scope.showInstallmentBannerContent = true;
                            $scope.showBannerContent = false;
                        } else {
                            $scope.showBannerContent = true;
                            $scope.showInstallmentBannerContent = false;
                        }
                        return true;
                    }
                    return false;
                };

                $scope.userSelectedFI = $scope.checkoutSession.getSelectedStickyInstrument() && $scope.checkoutSession.getSelectedStickyInstrument().instrument_id;

                $scope.updateStickyFS = function (stickyFI) {
                    if (stickyFI.instrument_id !== $scope.userSelectedFI) {
                        $scope.checkoutSession.action('setStickyFI', {
                            data: {
                                instrument_id: stickyFI.instrument_id
                            },
                            success: function success(result) {
                                $scope.checkoutSession.message = {
                                    type: 'success',
                                    msgKeys: ['paymentMethod.paymentMethodUpdated']
                                };
                                $scope.doneFn(result);
                            }
                        });
                    } else {
                        _uiRouter.$state.go('checkout.review');
                    }
                };

                var _fiSource = _this.fiSource,
                    isCardArtExp = _fiSource.isCardArtExp,
                    isBillingNoPurchase = _fiSource.isBillingNoPurchase;

                var masterPlanList = $scope.checkoutSession.getPlanList();
                var serializedPlans = {}; // index of all plans by primary and balance currency code(s)
                var balanceCodes = {}; // index of cataloged currency codes
                var primaryList = []; // list of plans with unique primaryFs ids
                var balanceList = $scope.balanceList = []; // list of unique balance currencies
                // determine if the selectFi variant is active
                var isSelectFiVariant = $scope.isSelectFiVariant = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi && $scope.models && $scope.models.choiceVariant && _squid.$config.choiceExperiment.selectFi.indexOf($scope.models.choiceVariant) !== -1;

                // Log our cardart FIs instrumentation if we're currently in the cardart experience
                if (isCardArtExp) {
                    _logger.$logger.info('checkout_fpti', _extends({
                        from: 'WALLET',
                        to: 'prepare_wallet'
                    }, _cardartInstrument.$CardArtInstrument.createPayload({
                        isBillingNoPurchase: isBillingNoPurchase,
                        checkoutSession: $scope.checkoutSession
                    })));
                }

                // TODO(refactor): $MultiFiPlanFactory.getSerializedPrimary()
                var getSerializedPrimary = function getSerializedPrimary(primary) {
                    var serial = primary.id + primary.amount.currency_code.toLowerCase();

                    // if there's a subtype...
                    if (primary.subtype) {
                        serial += primary.subtype;
                    }
                    return serial;
                };

                // return a serialized key for the plan
                // plan - a plan object from checkoutSession.fundingOptions.plans
                // balances - array of currency code strings
                // TODO (refactor): $MultiFiPlanFactory.getSerializedPlanId()
                var getSerializedPlanId = function getSerializedPlanId(plan, balances) {
                    var pid = getSerializedPrimary(plan.primaryFs);

                    // if no balances array...
                    if (!balances) {
                        // just return the pid
                        return pid;
                    }

                    // (otherwise) sort balances
                    balances.sort();

                    return pid + balances.join();
                };

                if (masterPlanList) {
                    var initiallyActiveBalances = [];
                    // TODO(refactor): $MultiFiPlanFactory.getShowBalanceCurrenciesStatus()
                    var showBalanceCurrencies = $scope.checkoutSession.isMultipleBalancePlan();

                    // if selectFi variant...
                    if (isSelectFiVariant) {

                        // if not multiple balance plans...
                        if (!showBalanceCurrencies) {
                            // start with first plan's currency
                            var knownCurrency = masterPlanList[0].primaryFs.amount.currency_code;

                            // update flag if any plan has more than two secondaries or one with a different currency
                            showBalanceCurrencies = masterPlanList.some(function (plan) {
                                // show currencies, when this plan has a different one, or...
                                return plan.primaryFs.amount.currency_code !== knownCurrency ||
                                // this plan has secondaries, where...
                                plan.secondaryFIs && (
                                // there's more than one
                                plan.secondaryFIs.length > 1 ||
                                // the one has a different currency
                                plan.secondaryFIs[0].amount.currency_code !== knownCurrency);
                            });
                        }

                        // index of captured primaryFs ids
                        var primaryFsIds = {};

                        // with each plan...
                        // TODO(refactor): use $MultiFiPlanFactory.getCompositeBalances() to get `balanceCodes`, `balanceList` and `balCurCodes`
                        masterPlanList.forEach(function (plan) {
                            var balances = plan.secondaryFIs || [];
                            var balCurCodes = [];

                            // if this is the active plan...
                            if ($scope.checkoutSession.plan.id === plan.planId) {
                                // capture it's balances - to be processed later
                                initiallyActiveBalances = balances;
                            }

                            // catalog balances
                            balances.forEach(function (balance) {
                                var code = balance.amount.currency_code;

                                // capture code (for serialization, next)
                                balCurCodes.push(code);
                                // if this code has not been cataloged...
                                if (!balanceCodes.hasOwnProperty(code)) {
                                    var balInfoAndState = {
                                        code: code,
                                        checked: false
                                    };

                                    if (showBalanceCurrencies) {
                                        balInfoAndState.amount = balance.amount.amount_formatted_currency;
                                    } else {
                                        balInfoAndState.amount = balance.amount.amount_formatted;
                                    }
                                    // flag that we've cataloged this code
                                    balanceCodes[code] = balInfoAndState;
                                    // capture balance details and initial ui state
                                    balanceList.push(balInfoAndState);
                                }
                            });

                            // if this is a primary split-balance plan...
                            if (plan.primaryFs.type === 'BALANCE') {
                                // add key to template
                                // NOTE: easier to build string here, than with template tags
                                plan.currencies = [plan.primaryFs.amount.currency_code].concat(balCurCodes).join(', ');
                            }

                            // catalog plan by serial and balances
                            serializedPlans[getSerializedPlanId(plan, balCurCodes)] = plan;

                            // get plan primary
                            var serialPrimary = getSerializedPrimary(plan.primaryFs);

                            // if haven't indexed the primary...
                            if (!primaryFsIds.hasOwnProperty(serialPrimary)) {
                                // note that we've cataloged this primary
                                primaryFsIds[serialPrimary] = 1;
                                // capture plan with unique primary
                                primaryList.push(plan);
                            }
                        });

                        // sort unique balances by currency code
                        balanceList.sort(function (balA, balB) {
                            // balance codes are never the same, so no need to return 0
                            return balA.code < balB.code ? -1 : 1;
                        });

                        // pre-check balances that match the active plan's balances (if any)
                        initiallyActiveBalances.forEach(function (balance) {
                            balanceCodes[balance.amount.currency_code].checked = true;
                        });
                    } else {
                        // (otherwise) use master as local and scoped list
                        primaryList = masterPlanList;
                    }

                    // expose to template
                    $scope.isMultipleBalance = showBalanceCurrencies;
                    // expose final list
                    $scope.primaryList = primaryList;
                }

                $scope.updateFS = function (index) {
                    // impacts when/how to notify user that balances were unusable
                    var unusableBalances = 0;
                    // impacts when/how to notify user that balances were required
                    var requiredBalances = 0;
                    // the plan to use
                    var fundingsource = void 0;

                    // flag when the plan has changed
                    var updateMessaging = function updateMessaging(planWasChanged) {
                        // if this is a primary balance plan...
                        if ($scope.checkoutSession.plan.sources[0].type === 'BALANCE') {
                            // suppress any info messages
                            unusableBalances = requiredBalances = 0;
                        }
                        if (unusableBalances) {
                            // show info message about failed balances
                            $scope.checkoutSession.message = {
                                type: 'info',
                                msgKeys: [unusableBalances === 1 ? 'memberReview.ryi_noBal' : 'memberReview.ryi_noBal_plural']
                            };
                        } else if (requiredBalances) {
                            // show info message about added balances
                            $scope.checkoutSession.message = {
                                type: 'info',
                                msgKeys: [requiredBalances === 1 ? 'memberReview.ryi_yesBal' : 'memberReview.ryi_yesBal_plural']
                            };
                        } else if (planWasChanged) {
                            // show that their selection went fine
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['paymentMethod.paymentMethodUpdated']
                            };
                        }
                    };

                    if (isSelectFiVariant) {
                        // get plan with serial, built from user selections
                        var checkedBalances = [];

                        // capture checked balance codes
                        _squid.$util.forEach(balanceCodes, function (balInfoAndState, code) {
                            if (balInfoAndState.checked) {
                                // capture balance object
                                // this is what getSerializedPlanId expects - ugh
                                checkedBalances.push(code);
                            }
                        });
                        var plan = primaryList[index];
                        var pid = void 0;
                        var pidForLogger = void 0;

                        // use plan with this primaryFs and balance options - if any
                        fundingsource = serializedPlans[getSerializedPlanId(plan, checkedBalances)];

                        // if no plan yet...
                        // (perhaps only one of the selected balances is applicable?)
                        if (!fundingsource) {
                            // resolve pid now
                            pid = getSerializedPrimary(plan.primaryFs);
                            pidForLogger = plan.primaryFs.id || plan.primaryFs.type;
                            // find a plan with each individual balance
                            checkedBalances.some(function (code) {
                                // match plan with this serial combination
                                fundingsource = serializedPlans[pid + code];
                                return fundingsource;
                            });
                            // flag that one of the checked balances was unusable
                            if (fundingsource) {
                                unusableBalances = 2;

                                _logger.$logger.info('checkout_fpti', {
                                    primary: pidForLogger,
                                    denied: checkedBalances.join()
                                });
                            }
                        }

                        // if no plan yet...
                        // (perhaps the plan doesn't have any balance combination?)
                        if (!fundingsource) {
                            // get the plan with just this primaryFs
                            fundingsource = serializedPlans[pid];
                            // if we now have a plan...
                            if (fundingsource) {
                                // note how many desired balances we're ignoring (if any)
                                unusableBalances = checkedBalances.length;

                                _logger.$logger.info('checkout_fpti', {
                                    primary: pidForLogger,
                                    denied: checkedBalances.join()
                                });
                            }
                        }

                        // if still no plan...
                        // (at this point, the plan requires a specific balance combination)
                        if (!fundingsource) {
                            var serializedPlanKeys = Object.keys(serializedPlans);

                            // use the first plan that begins with this primary
                            fundingsource = serializedPlans[serializedPlanKeys[_squid.$util.findIndex(serializedPlanKeys, function (serial) {
                                return serial.indexOf(pid) === 0;
                            })]];
                            // indicate that one or more balances were required for this plan
                            requiredBalances = balanceList.length;

                            _logger.$logger.info('checkout_fpti', {
                                primary: pidForLogger,
                                forced: balanceList.map(function (balance) {
                                    return balance.code;
                                }).join()
                            });
                        }
                    } else {
                        // (otherwise) when performing control logic...
                        // the first argument is the funding source
                        fundingsource = index;
                    }

                    // clear messaging - by default
                    $scope.checkoutSession.message = '';

                    if (fundingsource.infoMsg) {
                        $scope.disallowedIndex = index;
                        return;
                    }

                    // if the final plan hasn't changed...
                    if (fundingsource.planId === $scope.checkoutSession.plan.id) {
                        // tells user if any balances were not used or were required
                        updateMessaging();
                        // show message if balances were selected, but couldn't be used
                        $scope.doneFn();
                        return;
                    }

                    $scope.checkoutSession.fundingOptions.action('select', {
                        data: {
                            planId: fundingsource.planId
                        },
                        success: function success(result) {
                            $scope.checkoutSession.populate(result);

                            if (result) {
                                // Update the installments to support the user selecting a card that does not support installments.
                                $scope.checkoutSession.installments = result.installments;
                            }

                            if ($scope.checkoutSession.plan.paypal_credit && $scope.installment.showCYCO) {
                                _uiRouter.$state.go('checkout.chooseCreditOffer');
                            } else {
                                if (!fundingsource.selected) {
                                    // handle messaging around unusable balances (if any)
                                    // send flag that the plan was changed
                                    updateMessaging(true);

                                    if ($scope.checkoutSession.selectedInstallmentData && !$scope.checkoutSession.selectedInstallmentData.preventChange) {
                                        // Resetting selected installment data, if installment change is not explicitly prohibited.
                                        $scope.checkoutSession.selectedInstallmentData = undefined;
                                    }
                                }

                                $scope.doneFn(result);
                            }
                        },
                        contingencies: {
                            NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
                                if (result && result.resolution) {
                                    var card = result.resolution.data;

                                    if (card.fundingId && card.fi && card.fi.type) {
                                        $scope.cardModel.id = card.fundingId;
                                        $scope.cardModel.card = new _index2.$CardModel({
                                            number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                                            type: card.fi.type.toUpperCase(),
                                            productType: card.fi.productType
                                        });
                                    }
                                }

                                _uiRouter.$state.go('.confirmUpop');
                            }
                        }
                    });
                };

                $scope.shouldShowFSTile = function (fundingsource) {
                    var showFS = true;

                    if ($scope.isPadToggleFeatureApplicable()) {
                        // If PAD is not the current plan, then we will not show any PAD plan and show IACH plans.
                        // If PAD is the current plan, then we will visualize it as a bank plan and IACH plan without balance for corresponding bank will not be shown
                        if (!$scope.isCurrentPlanPad && fundingsource.primaryFs && fundingsource.primaryFs.subtype === 'PAD') {
                            showFS = false;
                        } else if ($scope.isCurrentPlanPad && fundingsource.primaryFs && fundingsource.primaryFs.subtype === 'PAD' && fundingsource.planId !== $scope.checkoutSession.plan.id) {
                            showFS = false;
                        } else if ($scope.isCurrentPlanPad && fundingsource.primaryFs && fundingsource.primaryFs.subtype === 'IACH' && fundingsource.primaryFs.id === $scope.checkoutSession.plan.sources[0].instrument_id) {
                            showFS = false;
                        }
                    }

                    return showFS;
                };
            });

            // Check if is variant where preferred label can be shown
            var preferredFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];

            this.preferredFiVariant = preferredFiVariants.indexOf(this.models.choiceVariant) > -1;
        }
    }
});


_angular.noop;

_uiRouter.$state;

_uiRouter.$stateParams;

_squid.$Component;

_squid.$populate;

_squid.$FallbackError;

_squid.$feature;

_squid.$locale;

_squid.$util;

_squid.$config;

_squid.$renderContent;

_squid.$promise;

_logger.$logger;

_choice.$ChoiceEligibility;

_index.$CheckoutSessionModel;

_index.$CheckoutCartModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutPayeeModel;

_index2.$AddCardModel;

_index2.$CardModel;

_index3.$CreditDataModel;

_index3.$CreditInstallmentModel;

_index4.$AuthModel;

_marketingoffer.$MemberSegmentModel;

_newMember.$NewMemberEligibility;

_factory.$ExpiredFiPanelFactory;

_cardartInstrument.$CardArtInstrument;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-wallet/directive.js
// module id = ./pages/xo-wallet/directive.js
// module chunks = 0